import { connect } from 'react-redux';
import FormInformation from '../../../components/event/event-details/form-information/index';
import {
    handleAddOnSiteDate,
    deleteOnSiteDate,
    createEventThunk,
    rejectEventThunk,
    approveEventThunk,
    requestInfoEventThunk,
    updateEventThunk,
    createAndSubmitEventThunk,
    updateAndSubmitEventThunk,
    resetEvent,
    setInvalidTabs,
    toggleEventRejectModal,
    toggleEventRequestModal,
    setEventUserAction,
    setEventErrorMessage,
    setPRModal,
    setPRComplete,
    setMCRCUploadedFile,
    setRegionalUploadedFile,
    setDistrictUploadedFile,
    setOnsiteActivations,
    updateAndApproveEventThunk,
    formSaved,
    toggleEventApproveModal,
    recallEventThunk
} from '../../../actions';

import { getEventActions, getEventStatus } from '../../../reducers';

const mapStateToProps = state => ({
    onSiteAddDates: state.ui.onSiteAddDates,
    eventActions: getEventActions(state),
    status: getEventStatus(state),
    userInfo: state.data.userInfo,
    hasActions: state.events.hasActions,
    userAction: state.events.userAction,
    approvers: state.events.approvers,
    tasks: state.events.tasks,
    eventSaveSubmit: state.events.eventSaveSubmit,
    eventApproveReject: state.events.eventApproveReject,
    prComplete: state.events.prComplete,
    prModalActive: state.events.prModal,
    approveModalActive: state.events.approveModalActive,
    onSiteDate: state.forms.event.onSiteDate,
    mcrcUploadedFile: state.events.mcrcUploadedFile,
    districtUploadedFile: state.events.districtUploadedFile,
    regionalUploadedFile: state.events.regionalUploadedFile,
    onsiteActivations: state.events.onsiteActivations,
    recommend: state.forms.event.recommend,
    recommendReason: state.forms.event.recommendReason,
    startDate: state.event.sDate,
    endDate: state.event.eDate,
    cost: state.forms.event.cost,
    purchaseRequest: state.PurchaseRequest
});

const mapDispatchToProps = dispatch => ({
    addOnSiteDate: date => dispatch(handleAddOnSiteDate(date)),
    deleteOnSiteDate: index => dispatch(deleteOnSiteDate(index)),
    createEvent: (data, vendors) => dispatch(createEventThunk(data, vendors)),
    rejectEvent: data => dispatch(rejectEventThunk(data)),
    approveEvent: data => dispatch(approveEventThunk(data)),
    requestInfoEvent: data => dispatch(requestInfoEventThunk(data)),
    updateEvent: (data, vendors) => dispatch(updateEventThunk(data, vendors)),
    resetEvent: () => dispatch(resetEvent()),
    createAndSubmitEvent: (data, vendors) =>
        dispatch(createAndSubmitEventThunk(data, vendors)),
    updateAndSubmitEvent: (data, vendors) =>
        dispatch(updateAndSubmitEventThunk(data, vendors)),
    setInvalidTabs: e => dispatch(setInvalidTabs(e)),
    toggleRejectModal: () => dispatch(toggleEventRejectModal()),
    toggleRequestModal: () => dispatch(toggleEventRequestModal()),
    toggleApproveModal: () => dispatch(toggleEventApproveModal()),
    setEventUserAction: action => dispatch(setEventUserAction(action)),
    setEventErrorMessage: text => dispatch(setEventErrorMessage(text)),
    hidePRModal: () => dispatch(setPRModal(false)),
    showPRModal: () => dispatch(setPRModal(true)),
    setPRComplete: bool => dispatch(setPRComplete(bool)),
    setMCRCUploadedFile: bool => dispatch(setMCRCUploadedFile(bool)),
    setRegionalUploadedFile: bool => dispatch(setRegionalUploadedFile(bool)),
    setDistrictUploadedFile: bool => dispatch(setDistrictUploadedFile(bool)),
    setOnsiteActivations: num => dispatch(setOnsiteActivations(num)),
    updateAndApproveEvent: data => dispatch(updateAndApproveEventThunk(data)),
    updateFormSave: bool => dispatch(formSaved(bool)),
    recallEventThunk: () => dispatch(recallEventThunk())
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FormInformation);



// WEBPACK FOOTER //
// ./src/containers/event/event-details/form-information.js